import React from 'react';

const FeatureCard = ({ 
  icon, 
  title, 
  description, 
  variant = "default", // "default", "accent", "card"
  className = ""
}) => {
  if (variant === "accent") {
    return (
      <div className={`p-6 bg-accent bg-opacity-20 rounded-xl hover:shadow-md transition-shadow ${className}`}>
        <div className="w-14 h-14 rounded-full bg-accent flex items-center justify-center mb-5">
          {icon}
        </div>
        <h3 className="text-xl font-semibold text-primary mb-3">{title}</h3>
        <p className="text-gray-700">{description}</p>
      </div>
    );
  }
  
  if (variant === "card") {
    return (
      <div className={`bg-white rounded-lg shadow transition-transform hover:scale-105 ${className}`}>
        <div className="p-6">
          <div className="w-14 h-14 rounded-full bg-accent flex items-center justify-center mb-5">
            {icon}
          </div>
          <h3 className="text-xl font-semibold text-primary mb-3">{title}</h3>
          <p className="text-gray-600">{description}</p>
        </div>
      </div>
    );
  }
  
  // Default variant
  return (
    <div className={`p-6 ${className}`}>
      <div className="w-14 h-14 rounded-full bg-accent flex items-center justify-center mb-5">
        {icon}
      </div>
      <h3 className="text-xl font-semibold text-primary mb-3">{title}</h3>
      <p className="text-gray-700">{description}</p>
    </div>
  );
};

export default FeatureCard;